module.exports = __webpack_public_path__ + "media/images/front/img_pd03-140808d6af2049fea618e9d8721c2ce0.jpg";